import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '@iso/lib/helpers/rtl';
import { handleShowRandomImage } from '@iso/constants/randomBackgrounds';

const PropertyCheckinLandingWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100vh;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  background: url(${handleShowRandomImage}) no-repeat center center;
  background-size: cover;

  .btn-success {
    background-color: #0b2a1b;
    border-color: #0b2a1b;
    &:hover {
      opacity: 0.8;
    }
  }

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    display: flex;
    background-color: rgba(0, 0, 0, 0.2);
    position: absolute;
    z-index: 1;
    top: 0;
    left: ${(props) => (props['data-rtl'] === 'rtl' ? 'inherit' : '0')};
    right: ${(props) => (props['data-rtl'] === 'rtl' ? '0' : 'inherit')};
  }

  .isoLoginContentWrapper {
    width: 500px;
    height: 100%;
    overflow-y: auto;
    z-index: 10;
    position: relative;
  }

  .isoLoginContent {
    min-height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 70px 50px;
    position: relative;
    background-color: #ffffff;

    @media only screen and (max-width: 767px) {
      width: 100%;
      padding: 70px 20px;
    }

    .isoLogoWrapper {
      width: 100%;
      display: flex;
      margin-bottom: 40px;
      justify-content: center;
      flex-shrink: 0;
    }
  }

  .property-checkin-role {
    .welcome-title {
      font-size: 22px;
      font-weight: 600;
      color: ${palette('text', 0)};
      margin-bottom: 8px;
      text-align: center;
    }
    .welcome-subtitle {
      color: ${palette('grayscale', 1)};
      text-align: center;
      margin-bottom: 24px;
    }
    .role-button {
      height: 48px;
      font-weight: 500;
    }
    .role-hint {
      font-size: 12px;
      color: ${palette('grayscale', 1)};
      margin: 6px 0 0;
    }
  }

  .property-checkin-form-step {
    .form-property-name {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 0;
    }
  }
`;

export default WithDirection(PropertyCheckinLandingWrapper);
